export default __webpack_public_path__ + "static/media/whats-icon.6bb3f6cd.png";